import * as React from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import SessionParticipantsDatesSubPanel from "./sessionParticipantsDatesSubPanel";
import { DetailsTabPanel } from "../../../../components/common/detailTabPanel/detailTabPanel";
import SessionParticipantsContactSubPanel from "./sessionParticipantsContactSubPanel";
import { useAreaPreference } from "../../../../hooks/useAreaPreference";
import { InventoryDetail } from "../../../../services/types/assessmentAPITypes";

interface SessionParticipantsPanelProps {
    sessionId: string;
    inventory?: InventoryDetail;
    inventoryIsFetching?: boolean;
}

const SessionParticipantsPanel: React.FC<SessionParticipantsPanelProps> = (props) => {
    const [activeTab, setActiveTab] = useAreaPreference<number>(
        "sessionDetail",
        "registrations.subTab",
        0,
    );

    const handleTabChange = (event: React.SyntheticEvent, newValue: number | null) => {
        if (newValue != null) setActiveTab(newValue);
    };

    const tablist: [string, number, React.ReactNode][] = [
        [
            "Contacts",
            0,
            <SessionParticipantsContactSubPanel
                sessionId={props.sessionId}
                inventory={props.inventory}
                inventoryIsFetching={props.inventoryIsFetching}
            />,
        ],
        [
            "Dates",
            1,
            <SessionParticipantsDatesSubPanel
                sessionId={props.sessionId}
                inventory={props.inventory}
                inventoryIsFetching={props.inventoryIsFetching}
            />,
        ],
    ];

    return (
        <>
            <Box
                sx={{
                    width: 1,
                    height: 1,
                    m: 2,
                    marginTop: 2,
                    borderWidth: 0,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Box
                    display={"flex"}
                    justifyContent={"center"}
                    sx={{ borderWidth: 0, flexGrow: 1 }}
                >
                    {tablist.length > 1 ? (
                        <ToggleButtonGroup
                            color="primary"
                            value={activeTab}
                            exclusive
                            onChange={handleTabChange}
                            sx={{ mb: 3 }}
                        >
                            {tablist.map((tab, i) => (
                                <ToggleButton
                                    key={tab[0].toLowerCase()}
                                    id={`session-details-registrations-tab-${tab[0].toLowerCase()}`}
                                    value={i}
                                >
                                    {tab[0]}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    ) : null}
                </Box>
                {tablist.map((tab, i) => (
                    <DetailsTabPanel
                        detailType={"session-details-registrations"}
                        key={tab[0]}
                        value={activeTab}
                        index={i}
                    >
                        {tab[2]}
                    </DetailsTabPanel>
                ))}
            </Box>
        </>
    );
};

export default SessionParticipantsPanel;
